import { Idea, Location, ideaHeight, ideaWidth } from "../model/types"

export type Rectangle = Location & {
  width: number
  height: number
}

export type QuadraticCurve = {
  from: Location
  control: Location
  to: Location
}

export const ideaRectangle = (idea: Idea): Rectangle => ({
  gx: idea.location.gx,
  gy: idea.location.gy,
  width: ideaWidth(idea),
  height: ideaHeight(idea),
})

export const ideaCenter = (idea: Idea): Location => {
  const rectangle = ideaRectangle(idea)

  return {
    gx: rectangle.gx + rectangle.width / 2,
    gy: rectangle.gy + rectangle.height / 2,
  }
}

export const rectangleInLocalCoordinates = (
  rectangle: Rectangle,
  localOrigin: Location,
): Rectangle => ({
  ...rectangle,
  gx: rectangle.gx - localOrigin.gx,
  gy: rectangle.gy - localOrigin.gy,
})

export const connectionCurve = (from: Location, to: Location): QuadraticCurve => {
  const vector = {
    gx: (to.gx - from.gx) / 2,
    gy: (to.gy - from.gy) / 2,
  }
  const rotatedVector = {
    gx: vector.gy,
    gy: -vector.gx,
  }

  return {
    from,
    control: {
      gx: from.gx + vector.gx + rotatedVector.gx / 2,
      gy: from.gy + vector.gy + rotatedVector.gy / 2,
    },
    to,
  }
}
